import { Box, Button, Dialog, Divider, Typography } from "@mui/material";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useAuth } from "src/hooks/use-auth";
import { snackAdded } from "src/slices/system";
import { selectCurrentPlan } from "src/slices/system/selectors";
import { getCheckoutLink } from "src/slices/system/thunks";
import { useDispatch } from "src/store";
interface AddPaymentModalProps {
  open: boolean;
  onClose: () => void;
  location?: any;
}
export interface CustomWindow extends Window {
  FPROM: any;
  Paddle: any;
}

declare let window: CustomWindow;

export const AddPaymentModal = ({
  open,
  onClose,
  location,
}: AddPaymentModalProps) => {
  const router = useRouter();
  const currentPlan = useSelector(selectCurrentPlan);
  const dispatch = useDispatch();
  const { user } = useAuth();
  const handleSubscribe = async (isCheckout: boolean) => {
    const link = await dispatch(getCheckoutLink({ planId: "885534" })).unwrap();

    //add override : link to checkoutObj
    let checkoutObj = {
      product: "885534",
      allowQuantity: false,
      disableLogout: true,
      email: user.email,
      success: `${window.location.origin}/app${router.asPath}?success=true`,
      override: link,
    };
    onClose();
    window.Paddle?.Checkout.open(checkoutObj);
  };

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);

    if (query.get("success")) {
      dispatch(
        snackAdded({
          type: "success",
          message: "Order placed! You will receive an email confirmation.",
        })
      );
    }
    if (query.get("canceled")) {
      dispatch(
        snackAdded({
          type: "error",
          message:
            "Order canceled - continue to shop around and checkout when you’re ready.",
        })
      );
    }
  }, [dispatch]);

  return (
    <Dialog onClose={onClose} open={open}>
      <Box width="464px">
        <Box
          display="flex"
          width="464px "
          height="526px"
          paddingTop="8px"
          flexDirection="column"
          justifyContent="flex-end"
          alignItems="center"
          sx={{
            position: "absolute",
            width: "100%",
            height: "8px",
            borderRadius: "4px 4px 0px 0px",
            background:
              "linear-gradient(60.66deg, #FFD875 -3.87%, #DA00C8 26.08%, #6A00FF 56.49%)",
          }}
        />

        <Box
          sx={{
            borderRadius: "0px 0px 8px 8px",
            background: "#FFFFFF",

            /* Wrapper Shadow */
            boxShadow: "0px 1px 2px 0px rgba(100, 116, 139, 0.10)",
          }}
          display="flex"
          padding="24px"
          flexDirection="column"
          alignItems="flex-start"
          gap="16px"
          alignSelf="stretch"
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
            alignSelf="stretch"
          >
            <Typography
              color="#121828"
              /* Heading/H1 */
              fontFamily="Inter"
              fontSize="20px"
              fontStyle="normal"
              fontWeight="500"
              lineHeight="normal"
            >
              You haven’t added payment method yet
            </Typography>
            <Typography
              width="19.267px"
              height="19.267px"
              flexShrink="0"
              sx={{
                cursor: "pointer",
              }}
              onClick={() => onClose()}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M2.69203 15.6063L8.66481 9.6335L2.69203 3.66072C2.46324 3.43568 2.33378 3.12787 2.33228 2.80725C2.33153 2.48588 2.45872 2.17807 2.686 1.95077C2.91329 1.72423 3.2211 1.59705 3.54248 1.59855C3.86385 1.60006 4.17091 1.72951 4.39595 1.95906L10.3664 7.93183L16.3392 1.95906C16.5642 1.72951 16.8713 1.60006 17.1927 1.59855C17.5133 1.59705 17.8218 1.72424 18.0491 1.95077C18.2764 2.17807 18.4036 2.48588 18.4021 2.80725C18.4014 3.12787 18.2719 3.43568 18.0431 3.66072L12.068 9.6335L18.0408 15.6063C18.2696 15.8313 18.399 16.1391 18.4005 16.4597C18.4013 16.7811 18.2741 17.0889 18.0468 17.3162C17.8195 17.5428 17.5117 17.6699 17.1903 17.6684C16.869 17.6669 16.5619 17.5375 16.3369 17.3079L10.3664 11.3352L4.39364 17.3079C3.9225 17.7723 3.16537 17.7693 2.69723 17.3027C2.22986 16.8353 2.2261 16.0782 2.68971 15.6063L2.69203 15.6063Z"
                  fill="#7B85AD"
                />
              </svg>
            </Typography>
          </Box>
          <Divider
            sx={{
              width: 416,
              height: 1,
              background: "#E6E8F0",
            }}
          />
          <Box alignSelf="stretch">
            <Typography
              color="#121828"
              fontFamily="Inter"
              fontSize="16px"
              fontStyle="normal"
              fontWeight="400"
              lineHeight="24px" /* 150% */
            >
              Start testing SEOwind with no worries - the trial is completely
              free! Just add a payment method to continue using the service
              after your 3-day trial.
            </Typography>
          </Box>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            gap="8px"
            alignSelf="stretch"
            padding="8px 16px"
            sx={{
              borderRadius: "8px",
              background: "#F9FAFC",
            }}
          >
            <Typography
              color="#121828"
              fontFamily="Inter"
              fontSize="14px"
              fontStyle="normal"
              fontWeight="600"
              lineHeight="normal"
            >
              Plan
            </Typography>
            <Typography
              color="#5048E5"
              fontFamily="Inter"
              fontSize="20px"
              fontStyle="normal"
              fontWeight="600"
              lineHeight="normal"
            >
              Pro
            </Typography>
          </Box>

          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            gap="8px"
            alignSelf="stretch"
            padding="8px 16px"
            sx={{
              borderRadius: "8px",
              background: "#F9FAFC",
            }}
          >
            <Typography
              color="#121828"
              fontFamily="Inter"
              fontSize="14px"
              fontStyle="normal"
              fontWeight="600"
              lineHeight="normal"
            >
              Billing cycle
            </Typography>
            <Typography
              color="#5048E5"
              fontFamily="Inter"
              fontSize="20px"
              fontStyle="normal"
              fontWeight="600"
              lineHeight="normal"
            >
              Monthly
            </Typography>
          </Box>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            gap="8px"
            alignSelf="stretch"
            padding="8px 16px"
            sx={{
              borderRadius: "8px",
              background: "#F9FAFC",
            }}
          >
            <Typography
              color="#121828"
              fontFamily="Inter"
              fontSize="14px"
              fontStyle="normal"
              fontWeight="600"
              lineHeight="normal"
            >
              Billed today
            </Typography>
            <Typography
              color="#5048E5"
              fontFamily="Inter"
              fontSize="20px"
              fontStyle="normal"
              fontWeight="600"
              lineHeight="normal"
            >
              $0
            </Typography>
          </Box>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            gap="8px"
            alignSelf="stretch"
            padding="8px 16px"
            sx={{
              borderRadius: "8px",
              background: "#F9FAFC",
            }}
          >
            <Typography
              color="#121828"
              fontFamily="Inter"
              fontSize="14px"
              fontStyle="normal"
              fontWeight="600"
              lineHeight="normal"
            >
              Billed later
            </Typography>
            <Typography
              color="#5048E5"
              fontFamily="Inter"
              fontSize="20px"
              fontStyle="normal"
              fontWeight="600"
              lineHeight="normal"
            >
              $89
            </Typography>
          </Box>

          <Divider
            sx={{
              width: 416,
              height: 1,
              background: "#E6E8F0",
            }}
          />

          <Box display="flex" gap="32px" alignItems="center">
            <Button
              variant="contained"
              color="primary"
              // onClick={}
              size="large"
              // disabled={isLoading || selected.length <= 0}
              sx={{
                mr: 1,
                width: "183px",
                display: "flex",

                padding: "8px 0px",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                background: "#5048E5",
              }}
              onClick={() => handleSubscribe(true)}
            >
              Add payment method
            </Button>

            <Typography
              color=" #7B85AD"
              textAlign="center"
              fontFamily="Inter"
              fontSize="12px"
              fontStyle="normal"
              fontWeight="600"
              lineHeight="normal"
              sx={{
                cursor: "pointer",
              }}
              onClick={() =>
                router.push({
                  pathname: "/dashboard/pricing",
                })
              }
            >
              Change Plan
            </Typography>
          </Box>
          <Divider
            sx={{
              width: 416,
              height: 1,
              background: "#E6E8F0",
            }}
          />

          <Box alignSelf="stretch">
            <Typography
              color=" #7B85AD"
              fontFamily="Inter"
              fontSize="12px"
              fontStyle="normal"
              fontWeight="400"
              lineHeight="normal"
            >
              You’ll only be charged after the 3-day trial ends. If you decide
              SEOwind isn’t for you, simply cancel before the trial ends to
              avoid any charges.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};
